import apiClient from './client';

export interface DeliveryRulesResponse {
  timezone: string;
  workingHours: { start: string; end: string };
  minLeadTimeMinutes: number;
  minLeadTimeMinutesExact: number;
  slotDurationMinutes: number;
  exactTimeExtraCostRub: number;
  afterHoursExtraCostRub: number;
  zones: Array<{ name: string; priceLabel: string; priceRub: number; requiresManagerApproval: boolean }>;
  display: {
    workingHours: string;
    afterHoursStart: string;
    afterHoursFee: string;
    avgTime: string;
  };
}

export interface DeliveryCalculateInput {
  mode?: 'delivery' | 'pickup' | null;
  city?: string | null;
  deliveryDate?: string | null;
  deliveryTime?: string | null;
  deliveryAsReady?: boolean;
  deliveryTimeType?: 'exact' | 'approximate' | 'night' | null;
}

export interface DeliveryCalculateResponse {
  earliestDeliveryDateTime: string;
  earliestDeliveryDate: string;
  earliestDeliveryTime: string;
  todayDate: string;
  tomorrowDate: string;
  isAfterHours: boolean;
  allowedTimeSlots: Array<{ date: string; slots: string[] }>;
  allowedApproximateWindows: Array<{ date: string; windows: string[] }>;
  zoneName: string;
  zoneType: 'known' | 'unknown';
  deliveryCostRub: number;
  extraCostRub: number;
  exactTimeExtraRub: number;
  requiresManagerApproval: boolean;
  explanationText: string;
  deliveryTimeType: 'exact' | 'approximate' | 'night' | null;
  display: {
    workingHours: string;
    afterHoursStart: string;
    afterHoursFee: string;
    avgTime: string;
  };
}

export async function getDeliveryRules(): Promise<DeliveryRulesResponse> {
  const response = await apiClient.get('/api/delivery/rules');
  return response.data.data;
}

export async function calculateDelivery(
  input: DeliveryCalculateInput
): Promise<DeliveryCalculateResponse> {
  const response = await apiClient.post('/api/delivery/calculate', input);
  return response.data.data;
}
